<template>
  <div   :class="['footer-bar', { 'mobile-class': isMobile }]">
   <div  class="footer-content">
    <el-row v-show="!isMobile" style="margin-left: 0; margin-top: 0;">
      <el-col :span="3" v-for="(link, index) in links" :key="index" style="text-align: left;font-size:var(--text-base);">
        <router-link style="color: rgba(240, 248, 255, 0.8); text-decoration: none;" :to="{ path: link.path }">{{ link.title }}</router-link>
      </el-col>
    </el-row>
    <el-row class="contact-info">
      <el-col :span="14" style="text-align: left;">
        <p style="font-size:var(--text-base);line-height:10px">博鳌职业教育大会组委会秘书处</p>
        <p style="font-size:var(--text-sm);line-height:10px">邮箱: cscdaad@163.com</p>
        <div class="phone-container">
          <span class="phone-item">电话: 冯老师 13811207753</span>
          <span class="phone-item">张老师 15011205062</span>
        </div>
        <p style="font-size:var(--text-sm);line-height:10px">地址: 北京朝阳区望京浦项中心A座17楼</p>
      </el-col>
      <el-col :span="10" class="qrcode">
         <img src="@/assets/qrcode.jpg" style="width:5rem;height:5rem;" alt="qrcode" class="qrcode">
      </el-col>
    </el-row>
   </div>
    <div style="display: flex; text-align: center; align-items: center;justify-content: center;  ">
        <a href="https://beian.miit.gov.cn/#/Integrated/index" style="color:  white;font-size:var(--text-sm); text-decoration: none;">版权所有博鳌职业教育发展大会-职教未来网 (浙ICP备2024127536号)</a>
     
    </div>
  </div>
</template>

<script>
export default {
  components: {
    
  },
  data() {
    return {   
      isMobile: false,
      links: [
        { title: '关于大会', name: 'AboutBackground',path:'/aboutConference/background' },
        { title: '新闻中心', name: 'NewsAnnouncements',path:'/news/announcements'},
        { title: '会议活动', name: 'EventsCurrent',path:'/events/currentEvents/0' },
        { title: '会员专区', name: 'MembersAbout',path:'/members/aboutMembers' },
        { title: '成果展示', name: 'InfluenceIndex',path:'/result/influenceIndex' },
        { title: '联系我们', name: 'Contact',path:'/contact' }
      ]
    };
  },
  mounted() {
    this.isMobile = window.innerWidth <= 768;
    
  },
  /**
   * 生命周期钩子 - 在实例创建完成后被调用
   * 设置组件的移动端状态标识，从 Vuex store 获取 isMobile 值
   * 并在控制台输出当前移动端状态
   */
  created() {
    this.isMobile = window.innerWidth <= 768;
     
  
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
      this.$store.commit('SET_MOBILE', this.isMobile);
    }, 
  }
  
};
</script>

<style>
.footer-bar {
  background-color: #333333;
  color: #e3eaf2;
  padding: 20px;
  
}
.footer-content {
  padding-left: 300px;
  padding-right: 300px;
}
.mobile-class{
  padding-left: 10px;
  padding-right: 10px;
}
 
@media screen and (max-width: 768px) {
  .footer-content {
    padding-left: 10px;
    padding-right: 10px;
}
}
.qrcode {
  text-align: right;
}

.phone-container {
  display: flex;
  align-items: center;
  font-size:var(--text-sm);
  line-height:10px;
}

.phone-item {
  margin-right: 20px;
}

.phone-item:last-child {
  margin-right: 0;
}

@media screen and (max-width: 768px) {
  .phone-container {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .phone-item {
    margin-right: 0;
    margin-bottom: 5px;
  }
  
  .phone-item:last-child {
    margin-bottom: 0;
  }
}
</style>